import React, { useEffect } from 'react';

interface IProps {
  ref: React.MutableRefObject<HTMLElement>;
  hash: string;
}

let id;
export const scrollTo = ($el, offset = 0, callback = null) => {
  if (!$el) return;

  clearInterval(id);

  let position = window.scrollY + $el.getBoundingClientRect().top + offset;
  position = Math.round(position);

  window.scrollTo({
    top: position,
    behavior: 'smooth',
  });

  if (callback) {
    id = setInterval(() => {
      if (position === window.scrollY) {
        clearInterval(id);
        callback();
      }
    }, 25);
  }
};

export const useHash = ({ ref, hash }: IProps) => {
  useEffect(() => {
    if (hash !== location.hash) return;

    const $el = ref.current;

    if (!$el) return;

    scrollTo($el);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
